// extracted by mini-css-extract-plugin
export var quillEditor = "_pj-1";
export var variable = "_pj-0";